import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as RolesActions from './client-role.action';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../helper/helper.service';
import { SaveState } from '../../models/commonModels';
import { RoleListModel, RoleObjectModel } from '../../models/roles/role';
import { ClientRoleService } from './client-role.service';

export interface ClientRoleStateModel {
    Role: RoleObjectModel;
    List: RoleListModel;
    Delete: SaveState;
  }

@State<ClientRoleStateModel>({
    name: 'clientRoleState',
    defaults: {
      Role: null,
      List: null,
      Delete: null,
    }
  })

  @Injectable()

  export class ClientRoleState {

    constructor(
      private helperService: HelperService,
      private rolesService: ClientRoleService,
      private bannerService: BannerService
    ) { }

  @Selector()
  static List(state: ClientRoleStateModel) {
    return state.List;
  }

  @Selector()
  static Role(state: ClientRoleStateModel) {
    return state.Role;
  }

  @Selector()
  static Delete(state: ClientRoleStateModel) {
    return state.Delete;
  }



  @Action(RolesActions.Get)
  getRole(
      context: StateContext<ClientRoleStateModel>,
      action: RolesActions.Get
    ) {
      context.setState(
        patch({
          Role: null
        })
      );

      const errorMessage = 'Błąd pobierania danych o Roli.';

      this.rolesService.getRole(action.RoleId).subscribe((ret) => {

        if (ret.Success) {
          context.setState(
            patch({
              Role: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException('RoleActions.getRole', error);

        this.bannerService.error(errorMessage);
        });
  }

  @Action(RolesActions.GetList)
  getList(
    context: StateContext<ClientRoleStateModel>,
    action: RolesActions.GetList
  ) {
    const errorMessage = 'Błąd pobierania listy ról';

    context.setState(
      patch({
        List: null
      })
    );

    this.rolesService.getRoles().subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            List: ret
          })
        );
        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('RolesActions.getList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(RolesActions.Delete)
  delete(
    context: StateContext<ClientRoleStateModel>,
    action: RolesActions.Delete
  ) {

    const errorMessage = 'Błąd usuwania roli';

    this.rolesService.deleteRole(action.RoleId).subscribe((ret) => {
      if(ret.Success)
      {
      this.bannerService.success('Rola usunięta.');
      context.setState(
        patch({
          Delete: new SaveState(action.RoleId, true)
        })
      );
      }else{
        this.bannerService.error("Błąd usuwania roli, " + ret.Message);
        context.setState(
          patch({
            Delete: new SaveState(action.RoleId, false)
          }));
      }
    },
      (error) => {
        this.helperService.SaveException('RolesActions.deleteRole', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(RolesActions.Set)
  setRole(
    context: StateContext<ClientRoleStateModel>,
    action: RolesActions.Set
  ) {
    const errorMessage = 'Błąd zapisu roli.';

    this.rolesService.setRole(action.Role).subscribe(
      ret => {
        if(action.Role.RoleId)
          this.bannerService.success('Zmiany w roli zapisane.');
        else
          this.bannerService.success('Dodano nową role.');
        context.setState(
          patch({
            Role: ret,
          })
        );
      },

      (error) => {
        this.helperService.SaveException('RolesActions.SetRole', error);

        this.bannerService.error(errorMessage);
      },
      () => {});
  }
}

